module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Router":{"routes.@":[{"value":"\u003Ehome","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Router","_fox_":1}],"routes.@miss":[{"value":"#404 #404","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/options/routes.js
// module id = 223
// module chunks = 2